import React from 'react';
import { Layout } from 'antd';
import PrivateMenu from '../menus/PrivateMenu';
import UIStore from '@/stores/UIStore';

const { Sider } = Layout;

export const SideNav = () => {
    return (
        <Sider
            className="side-nav"
            width={220}
            style={{
                position: 'static',
            }}
        >
            <PrivateMenu isDrawer={false} />
        </Sider>
    );
};

export default SideNav;
